module.exports = require("./../../_gen/starling/rendering/FilterEffect");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/FilterEffect.js
// module id = 213
// module chunks = 0